/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAnnouncementsRelevanceConfirmModel,
  IAnnouncementsRelevanceConfirmRequest,
  IMappers,
  IAnnouncementsRelevanceConfirmResponseError,
  TAnnouncementsRelevanceConfirmResponse,
} from './types';

const defaultConfig: TAnnouncementsRelevanceConfirmModel = {
  apiType: 'public',
  assertStatusCodes: [204, 400],
  method: 'GET',
  microserviceName: 'moderation-announcements-relevance',
  pathApi: '/v3/announcements-relevance/confirm/',
  hostType: 'api',
} as TAnnouncementsRelevanceConfirmModel;

function createAnnouncementsRelevanceConfirmModel(
  parameters: IAnnouncementsRelevanceConfirmRequest,
): TAnnouncementsRelevanceConfirmModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAnnouncementsRelevanceConfirmOptions<TResponse204, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAnnouncementsRelevanceConfirmRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse204, TResponse400>;
}

async function fetchAnnouncementsRelevanceConfirm<TResponse204, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAnnouncementsRelevanceConfirmOptions<TResponse204, TResponse400>): Promise<
  TResponse204 | TResponse400 | TAnnouncementsRelevanceConfirmResponse
> {
  const { response, statusCode } = await httpApi.fetch(createAnnouncementsRelevanceConfirmModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 204) {
      return mappers[204]();
    }

    if (statusCode === 400) {
      return mappers[400](response as IAnnouncementsRelevanceConfirmResponseError);
    }
  }

  return { response, statusCode } as TAnnouncementsRelevanceConfirmResponse;
}

export { defaultConfig, createAnnouncementsRelevanceConfirmModel, fetchAnnouncementsRelevanceConfirm };
